import { Dialog, DialogTitle, DialogContent, Alert, Box, FormControl, TextField, InputLabel, Select, SelectChangeEvent, MenuItem, DialogActions, Button, Typography, RadioGroup, FormControlLabel, Radio, FormLabel } from '@mui/material';
import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { TipoVia } from '../TiposVia/TipoVia';
import { TipoViaVariacion } from '../TiposViaVariaciones/TipoViaVariacion';

export interface IRepairTIpoViaProps {
    id: number;
    variacion: string;
    open: boolean;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairTIpoViaState {
    data: any[];
    open: boolean;
}

export default class RepairTIpoVia extends React.Component<IRepairTIpoViaProps, IRepairTIpoViaState> {
    _tipoViaVaracion: TipoViaVariacion = new TipoViaVariacion();
    _variacion: string = '';

    public constructor(props: IRepairTIpoViaProps) {
        super(props);

        this.state = {
            data: [],
            open: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairTIpoViaProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });

        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    {
                        `Reparar tipo de vía`
                    }
                </DialogTitle>
                <DialogContent>
                    <Typography variant='body2'>
                        {
                            `Seleccione un tipo de vía para asignar la variación ${this.props.variacion}`
                        }
                    </Typography>
                    <FormControl required fullWidth variant="standard" style={{marginTop: '10px'}}>
                        <InputLabel id="labelComunidadAutonoma">Seleccione un tipo de vía</InputLabel>
                        <Select label="Seleccione un tipo de vía" labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                            this._tipoViaVaracion.tipoVia = event.target.value;
                        }}>
                            {
                                this.state.data.map((value: TipoVia, index: number) => {
                                    return (
                                        <MenuItem value={value.nombre} key={index}>
                                            {
                                                value.nombre
                                            }
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>Ok</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Save() {
        this._tipoViaVaracion.nombre = this.props.variacion;
        
        let url = `${Common.END_POINT}/masters/tipoviavariaciones`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._tipoViaVaracion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {    
            if(this.props.onSave != null) {
                this.props.onSave(this.props.id);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            if(this.props.onSave != null) {
                this.props.onSave(this.props.id);
            }
        });
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }

    private Get(): void {
        let url = `${Common.END_POINT}/masters/tiposvia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: TipoVia[]) => {
            this.setState(
                {
                    data: response
                }
            );
        });
    }
}